import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const NotificationFooterWrapper = styled.div`
  box-sizing: border-box;
  height: 64px;
  background: ${Colors.white};
  border-top: 1px solid ${Colors.neutral_gray_300};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  bottom: 0;
  width: 100%;
`;

export const NotificationFooterText = styled.div<{
  disable: boolean;
}>`
  font-family: "Ringside Regular-Bold";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-transform: capitalize;
  color: ${(props) =>
    props.disable ? Colors.primarygray_300 : Colors.primary};
`;

export const NotificationButtonWrapper = styled.div<{
  disable: boolean;
}>`
  cursor: ${(props) => (props.disable ? "not-allowed" : "pointer")};
`;

export const FooterNotificationCount = styled.div`
  font-family: "Ringside Regular-Book";
  font-style: normal;
  font-weight: 325;
  font-size: 16px;
  line-height: 24px;

  color: ${Colors.neutral_gray_500};
`;
